module.exports = __webpack_public_path__ + "static/03-6ed56c6b4cdf85ad7d0a35504f63b33a.jpg";